import { featuredStory } from "@/mocks/gossip";

const COVER_IMG =
  "https://readdy.ai/api/search-image?query=Editorial%20news%20report%20style%20dramatic%20composition%20of%20a%20laptop%20screen%20showing%20social%20media%20scandal%20timeline%2C%20coral%20red%20and%20cream%20palette%2C%20floating%20evidence%20documents%20and%20magnifying%20glass%2C%20viral%20warning%20sign%2C%20dark%20cinematic%20lighting%20on%20side%2C%20high%20detail%20digital%20illustration%2C%20no%20faces&width=800&height=900&seq=gossip-scene-cover&orientation=portrait";

export default function SceneSection() {
  const story = featuredStory;

  return (
    <section id="scene" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-primary-600">
            <span className="h-px w-8 bg-primary-400"></span> 逐帧还原
          </p>
          <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950">
            完整过程 · 现场逐帧还原
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            本期头条把「{story.person}」的翻车全程拆成可回溯的时间线，证据来源与前后对比已标注，方便你按步骤吃瓜。
          </p>
        </div>

        <div className="mt-9 grid lg:grid-cols-[380px_1fr] gap-8 items-start">
          {/* story cover card */}
          <div className="lg:sticky lg:top-24">
            <div className="rounded-3xl overflow-hidden border border-background-200">
              <img src={COVER_IMG} alt={story.coverAlt} className="w-full h-[420px] object-top object-cover" />
            </div>
            <div className="mt-5 rounded-2xl bg-background-100 border border-background-200 p-5">
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                  <i className="ri-error-warning-fill"></i>{story.verdict}
                </span>
                <span className="text-xs text-foreground-500">{story.platform}</span>
              </div>
              <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950 leading-snug">
                {story.title}
              </h3>
              <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
                {story.intro}
              </p>
              <div className="mt-4 flex items-center gap-3 text-sm">
                <span className="inline-flex items-center gap-1.5 text-foreground-600">
                  <i className="ri-user-3-line"></i>{story.person}
                </span>
                <span className="inline-flex items-center gap-1.5 text-accent-700 font-medium">
                  <i className="ri-group-line"></i>{story.follower}
                </span>
              </div>
              <a
                href="#evidence"
                className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-foreground-950 px-4 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                查看前后对比证据 <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          {/* timeline steps */}
          <div className="relative">
            <div className="absolute left-[19px] md:left-[23px] top-2 bottom-2 w-px bg-background-300"></div>
            <div className="space-y-4">
              {story.steps.map((step, idx) => (
                <div key={step.time} className="relative flex gap-5 md:gap-7">
                  <div className="relative z-10 flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full shrink-0 bg-background-100 border-2 border-primary-300 text-primary-600">
                    <i className="ri-flashlight-line text-lg"></i>
                  </div>
                  <div className="flex-1 rounded-2xl bg-background-100/70 border border-background-200 p-4 md:p-5">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="font-latin text-xl text-primary-600 tracking-wide">
                        {String(idx + 1).padStart(2, "0")}
                      </span>
                      <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950">
                        {step.title}
                      </h3>
                      <span className="ml-auto rounded-full bg-secondary-100 text-secondary-800 px-2.5 py-0.5 text-[11px] font-medium whitespace-nowrap">
                        {step.time}
                      </span>
                    </div>
                    <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">
                      {step.detail}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}